import React, { ReactNode } from 'react';
import { DocumentStatusEnum } from '../../../shared/constants/document';

import classNames from 'classnames';
import './document-badge.scss';
import { getClassNameForStatus } from '../document-badge-container/helpers';

type DocumentBadgeProps = {
  documentStatus: DocumentStatusEnum;
  children: ReactNode | string;
};
export const DocumentBadge = ({ documentStatus, children }: DocumentBadgeProps) => (
  <small role="presentation" className={classNames('document-badge', getClassNameForStatus(documentStatus))}>
    {children}
  </small>
);
